(() => {
  let registered = false;
  let retryTimer;
  let attempts = 0;
  function register() {
    const context = document.modelContext || navigator.modelContext;
    if (registered) return;
    if (!context?.registerTool) {
      if (!retryTimer && attempts < 20) {
        attempts += 1;
        retryTimer = setTimeout(() => {
          retryTimer = undefined;
          register();
        }, 500);
      }
      return;
    }
    if (retryTimer) clearTimeout(retryTimer);

    const root = window.Shopify?.routes?.root || '/';
    const searchUrl = new URL(`${root}search`, window.location.origin);

    context.registerTool({
      name: 'search_alwan_catalog',
      description: 'Search Alwan Alsahel products in Arabic or English, with live EGP prices, variant IDs, availability and stored specifications. Use this tool for Arabic product searches, including بديل الخشب, استانلس, مناظر 3D, ورق حائط and استيكر. It uses standard storefront search when predictive search is unavailable. Read only: does not add items, navigate, or start checkout. Unknown pack counts and dimensions are returned as null; do not infer what quantity 1 contains.',
      annotations: { readOnlyHint: true, untrustedContentHint: true },
      inputSchema: {
        type: 'object',
        properties: {
          query: { type: 'string', description: 'Product name, category, code, material or use case.' },
          limit: { type: 'integer', minimum: 1, maximum: 10, default: 5 },
        },
        required: ['query'],
        additionalProperties: false,
      },
      async execute(input, client = {}) {
        const query = typeof input?.query === 'string' ? input.query.trim() : '';
        if (!query || query.length > 250) {
          return { isError: true, content: [{ type: 'text', text: 'Provide a product search of 1–250 characters.' }] };
        }
        const limit = Number.isInteger(input.limit) ? Math.min(10, Math.max(1, input.limit)) : 5;
        const url = new URL(searchUrl);
        url.searchParams.set('q', query);
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[prefix]', 'last');
        url.searchParams.set('section_id', 'alwan-agent-search');
        try {
          const response = await fetch(url, { credentials: 'same-origin', signal: client.signal });
          if (!response.ok) throw new Error(`Search returned HTTP ${response.status}.`);
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const payload = html.querySelector('[data-alwan-agent-search-results]');
          if (!payload) throw new Error('Structured search results are unavailable.');
          const data = JSON.parse(payload.textContent);
          if (!Array.isArray(data.products)) throw new Error('Invalid search response.');
          data.products = data.products.slice(0, limit);
          const resultUrl = new URL(searchUrl);
          resultUrl.searchParams.set('q', query);
          resultUrl.searchParams.set('type', 'product');
          resultUrl.searchParams.set('options[prefix]', 'last');
          data.search_url = resultUrl.href;
          data.returned_count = data.products.length;
          return {
            content: [{ type: 'text', text: JSON.stringify(data) }],
            structuredContent: data,
          };
        } catch (error) {
          return {
            isError: true,
            content: [{ type: 'text', text: `Product search failed: ${error.message} Use the store's collection pages or full search page; do not interpret this error as no matching products.` }],
          };
        }
      },
    });
    registered = true;
  }
  register();
  document.addEventListener('DOMContentLoaded', register, { once: true });
  document.getElementById('shopify-origin-trials')?.addEventListener('load', register, { once: true });
})();
